/**
 * 删除图层：与 Delete/Backspace 同能力，挂到图层快捷条。
 */
import { getLocaleStore } from '@/i18n';
import type { IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { ShortcutToolbarIconItem } from '@/plugins/shortcut-menu/views/shortcut-toolbar-widgets';

export const layerDeleteShortcutItem = ({ framework }: IShortcutMenuItemRenderArgs) => {
    const { $t } = getLocaleStore();

    return (
        <ShortcutToolbarIconItem
            name="TrashCanBold"
            title={$t((v) => v.baseLayer.shortcutOperate.delete)}
            onClick={(e) => {
                e.stopPropagation();
                framework.service.hotkey.__emitDelete({ from: 'shortcut-menu' });
                // framework.service.registration
                //     .getInstance<ShortcutMenu>('ShortcutMenu')
                //     .emitClick(SHORTCUT_FUNC_MAP.delete);
            }}
        />
    );
};
